export default "__VITE_ASSET__Dcml1XgM__"